import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const MarketplaceHeader = () => {
  const navigate = useNavigate();

  return (
    <header className="sticky top-0 z-50 backdrop-blur-xl bg-[#0B1220]/90 border-b border-white/10">
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-4">
            <button onClick={() => navigate('/enterprise-landing-page')} className="flex items-center gap-3 hover:opacity-80 transition-opacity">
              <div className="w-10 h-10 bg-[#FFD100] rounded-lg flex items-center justify-center">
                <Icon name="Zap" size={24} color="#0B1220" strokeWidth={2.5} />
              </div>
              <span className="text-xl font-bold text-white">First On Date</span>
            </button>
            <div className="hidden md:block w-px h-6 bg-white/20"></div>
            <span className="hidden md:block text-white/60">Integrations Marketplace</span>
          </div>

          <div className="flex items-center gap-4">
            <Button
              variant="outline"
              size="md"
              onClick={() => navigate('/enterprise-landing-page')}
              className="border border-white/20 text-white hover:bg-white/10">
              Back to Home
            </Button>
            <Button
              variant="default"
              size="md"
              onClick={() => navigate('/login-authentication')}
              className="bg-[#FFD100] hover:bg-[#FFD100]/90 text-[#0B1220] font-semibold">
              Get Started
            </Button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default MarketplaceHeader;